import * as React from 'react';

const TipIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={props.stroke || '#A4B8FD'}
      strokeLinecap="round"
      strokeOpacity="0.51"
      strokeWidth="1.5"
      d="M8 10.6V7.35m0-2.34V5m6.25 3a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0Z"
    ></path>
  </svg>
);

export default TipIcon;
